<template>
  <l-modal :showing="showing" text="Network" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/4 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          />
        </div>
        <div class="w-3/4">
          <b>Name</b>
          <br />
          <l-input placeholder="Enter 'Name' (text)" v-model="editObj.name" inputClass="text-2xs" />
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Media Monitored</b>
          <br />
          <l-select
            v-model="editObj.media_monitored"
            class="text-xs"
            :data="mediavalues"
            :multiple="false"
          >
            <l-option
              v-for="i in mediavalues"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Responsible authority</b>
          <br />
          <l-select
            v-model="editObj.responsible_authority_id"
            class="text-xs"
            :data="responsible_authorities"
            :multiple="false"
          >
            <l-option
              v-for="i in responsible_authorities"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Organisational</b>
          <br />
          <l-select
            v-model="editObj.organisational"
            class="text-xs"
            :data="organisationallevels"
            :multiple="false"
          >
            <l-option
              v-for="i in organisationallevels"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Timezone</b>
          <br />
          <l-select
            v-model="editObj.aggregation_timezone"
            class="text-xs"
            :data="timezones"
            :multiple="false"
          >
            <l-option
              v-for="i in timezones"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Begin position</b>
          <br />
          <l-input v-model="editObj.begin_position" type="text" placeholder="YYYY-MM-DDTHH:mm:ssZ" />
        </div>
        <div class="w-1/2">
          <b>End position</b>
          <br />
          <l-input
            v-model="editObj.end_position"
            type="text"
            placeholder="YYYY-MM-DDTHH:mm:ssZ (optional)"
          />
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: [
    "showing",
    "network",
    "responsible_authorities",
    "timezones",
    "mediavalues",
    "organisationallevels",
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.network);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      const mv = this.mediavalues.find(
        r => r.value == this.editObj.media_monitored
      );
      this.editObj.media_monitored_name = mv.label;

      const ra = this.responsible_authorities.find(
        r => r.value == this.editObj.responsible_authority_id
      );
      this.editObj.responsible_authority_name = ra.label;

      const ol = this.organisationallevels.find(
        r => r.value == this.editObj.organisational
      );
      this.editObj.organisational_name = ol.label;

      const tz = this.timezones.find(
        r => r.value == this.editObj.aggregation_timezone
      );
      this.editObj.aggregation_timezone_name = tz.label;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>